import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19.7 16.8667H16.94L11.5733 0.76667C11.2667 -0.306663 9.73333 -0.306663 9.42666 0.76667L4.05999 16.8667H1.29999C0.839992 16.8667 0.533325 17.1733 0.533325 17.6333V19.1667C0.533325 19.6267 0.839992 19.9333 1.29999 19.9333H19.7C20.16 19.9333 20.4667 19.6267 20.4667 19.1667V17.6333C20.4667 17.1733 20.16 16.8667 19.7 16.8667ZM9.73333 4.6H11.2667L12.34 7.66667H8.81332L9.73333 4.6ZM7.73999 10.7333H13.26L14.3333 13.8H6.66666L7.73999 10.7333Z" }, null, -1)
  ])))
}
export default { render: render }